import React from 'react';
import CameraFrame from '../../components/ui/CameraFrame';
import { activeProject } from '../../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMapPin, FiCalendar, FiTarget, FiPieChart } = FiIcons;

const Overview = () => {
  const progressPercent = Math.round((activeProject.deliverablesTracker.completed / activeProject.deliverablesTracker.total) * 100);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      {/* Main Brief */}
      <div className="lg:col-span-2 space-y-6">
        <CameraFrame className="p-6 md:p-8">
          <div className="flex items-start justify-between mb-6">
            <div>
              <p className="font-mono text-xs text-pink-500 tracking-[0.2em] uppercase mb-2">Shoot Brief</p>
              <h2 className="text-3xl font-bold text-white tracking-wide">{activeProject.title}</h2>
              <p className="font-mono text-sm text-[#888] mt-1">Client: {activeProject.client}</p>
            </div>
            <div className="px-3 py-1 border border-pink-500/50 bg-pink-500/10 text-pink-500 font-mono text-xs uppercase tracking-wider">
              {activeProject.status}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-center gap-3 text-sm font-mono text-[#aaa]">
              <SafeIcon icon={FiCalendar} className="text-[#555]" />
              {new Date(activeProject.date).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })}
            </div>
            <div className="flex items-center gap-3 text-sm font-mono text-[#aaa]">
              <SafeIcon icon={FiMapPin} className="text-[#555]" />
              {activeProject.location}
            </div>
          </div>

          <div className="space-y-2">
            <p className="font-mono text-xs text-[#666] tracking-widest uppercase flex items-center gap-2">
              <SafeIcon icon={FiTarget} /> Objective
            </p>
            <p className="text-[#ddd] leading-relaxed text-sm">
              {activeProject.brief}
            </p>
          </div>
        </CameraFrame>

        {/* Quick Stats / Recent Moodboard */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <CameraFrame className="p-6">
             <p className="font-mono text-xs text-[#666] tracking-widest uppercase mb-4">Latest References</p>
             <div className="flex gap-2 overflow-hidden">
                {activeProject.moodboard.slice(0, 3).map((img, i) => (
                  <div key={i} className="h-24 flex-1 bg-[#222] relative group overflow-hidden border border-[#333]">
                    <img src={img} alt="ref" className="w-full h-full object-cover opacity-60 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500" />
                  </div>
                ))}
             </div>
          </CameraFrame>
          
          <CameraFrame className="p-6 flex flex-col justify-center items-center text-center">
            <p className="font-mono text-xs text-[#666] tracking-widest uppercase mb-2">Team Size</p>
            <div className="text-4xl font-mono text-white mb-1">
              {activeProject.logistics.crew.length} <span className="text-sm text-[#555]">PAX</span>
            </div>
            <p className="font-mono text-[10px] text-pink-500">ALL CONFIRMED</p>
          </CameraFrame>
        </div>
      </div>

      {/* Deliverables Sidebar */}
      <div className="space-y-6">
        <CameraFrame className="p-6 h-full flex flex-col">
          <h3 className="font-mono text-sm text-white tracking-widest uppercase mb-6 flex items-center gap-2 border-b border-[#333] pb-3">
            <SafeIcon icon={FiPieChart} className="text-pink-500" />
            Deliverables
          </h3>
          
          <div className="flex-1 flex flex-col justify-center items-center mb-8">
            <div className="relative w-40 h-40 flex items-center justify-center mb-4">
              {/* Fake SVG Donut Chart */}
              <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#222" strokeWidth="10" />
                <circle 
                  cx="50" cy="50" r="45" fill="none" stroke="#ec4899" strokeWidth="10" 
                  strokeDasharray={`${progressPercent * 2.82} 282`} 
                  className="transition-all duration-1000 ease-out"
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-3xl font-mono text-white">{progressPercent}%</span>
                <span className="text-[10px] font-mono text-[#666] uppercase">Exported</span>
              </div>
            </div>
          </div>

          <div className="space-y-4 font-mono text-sm">
            <div className="flex justify-between items-center bg-[#1a1a1a] p-3 border border-[#333]">
              <span className="text-[#888]">Total Assets</span>
              <span className="text-white">{activeProject.deliverablesTracker.total}</span>
            </div>
            <div className="flex justify-between items-center bg-[#1a1a1a] p-3 border border-[#333] border-l-2 border-l-pink-500">
              <span className="text-[#888]">Completed</span>
              <span className="text-white">{activeProject.deliverablesTracker.completed}</span>
            </div>
            <div className="flex justify-between items-center bg-[#1a1a1a] p-3 border border-[#333] border-l-2 border-l-yellow-500">
              <span className="text-[#888]">In Review</span>
              <span className="text-white">{activeProject.deliverablesTracker.pendingReview}</span>
            </div>
          </div>
          
          <button className="w-full mt-6 py-3 bg-pink-500 hover:bg-pink-600 text-white font-mono text-xs uppercase tracking-widest transition-colors shadow-[0_0_15px_rgba(236,72,153,0.3)]">
            Export Gallery
          </button>
        </CameraFrame>
      </div>
    </div>
  );
};

export default Overview;